import { asyncWithLDProvider, LDContext } from "launchdarkly-react-client-sdk";
import { LaunchDarklyFeatureFlags } from "./featureFlagUtils";

declare global {
  // Set by the Playwright E2E suite before the app loads; other modules extend it.
  interface E2eWindow {
    featureFlags?: Partial<LaunchDarklyFeatureFlags>;
  }

  interface Window {
    e2e?: E2eWindow;
  }
}

export interface AnonymousContext {
  anonymous: true;
  key?: string;
}

export interface Context {
  user:
    | { key: string; name?: string; email?: string; avatar?: string }
    | AnonymousContext;
  organisation: { key: string; name?: string } | AnonymousContext;
}

export type ContextKey = keyof Context;

export const ANONYMOUS_CONTEXT: AnonymousContext = {
  anonymous: true,
  // LaunchDarkly targeting rules match E2E runs on this context key.
  key: window.e2e ? "cypress" : undefined,
};

export const INITIAL_CONTEXT: LDContext = {
  kind: "multi",
  user: ANONYMOUS_CONTEXT,
};

export async function initialiseLaunchDarkly() {
  return asyncWithLDProvider({
    clientSideID: import.meta.env.VITE_LAUNCH_DARKLY_CLIENT_ID,
    context: INITIAL_CONTEXT,
  });
}
